module.exports = __webpack_public_path__ + "media/images/map_icons/Hockey-0083df18429bd7ff56a0e1584440b533.svg";